import React, { useState } from 'react';


function TaxForm() {
    const [taxType, setTaxType] = useState('');
    const [income, setIncome] = useState(0);
    const [incomePit,setIncomePit] = useState(0);
    const [flatTaxRate, setFlatTaxRate] = useState(8.5);
    const [taxCardRate, setTaxCardRate] = useState('');
    const [miesiace, setMiesiace] = useState(12);
    const [creditValue, setCreditValue] = useState(300000);
    const [loanPeriod, setLoanPeriod] = useState(300);
  
  
    const handleTaxTypeChange = (event) => {
      setTaxType(event.target.value);
    };
  
    const handleIncomeChange = (event) => {
      setIncome(event.target.value);
    };
    
    const handleIncomePitChange = (event) => {
      setIncomePit(event.target.value);
    }
  
    const handleFlatTaxRateChange = (event) => {
      setFlatTaxRate(event.target.value);
    };
  
    const handleTaxRateChange = (event) => {
      setTaxCardRate(event.target.value);
    }
  
    const handleMiesiaceChange = (event) => {
      setMiesiace(event.target.value);
    }
  
    const handlecreditValueChange = (event) => {
      setCreditValue(event.target.value);
    }
  
    const handleloanPeriodChange = (event) => {
      setLoanPeriod(event.target.value);
    }
  
    //const handleNetto = (event) => { -- nie jest to wymagane
   //   setNetto(event.target.value);
   // }
    
    let taxAmount = 0;
    if (taxType === 'linear') {
      taxAmount = income * 0.19;
    } else if (taxType === 'progressive') {
      if (income <= 85528) {
        taxAmount = income * 0.13;
      } else if (income > 85528) {
        taxAmount = 14539.76 + (income - 85528) * 0.32;
      }
    } else if (taxType === 'flat') {
      taxAmount = income * (flatTaxRate / 100);
    } else if (taxType === 'taxcard') {
      taxAmount = taxCardRate * 12;
    }
  
   let ubValue = 1037;
   const a = 12;
   const b = miesiace;
   const c = a - b;
   const d = 24 - c;
  
   let nettoValue = income - (miesiace * ubValue);
   
   let nettoValuePit = incomePit - (12 * ubValue);
  
   let nettoValuefull = nettoValue + nettoValuePit; 
  
   let mbankLinearMonth = nettoValue + ((nettoValuePit/12) * c);
   
   let veloLinearMonth = mbankLinearMonth;
   if (veloLinearMonth > nettoValuePit){
    veloLinearMonth = nettoValuePit;
   }
  
    return (
      <form className="tax-form">
        <label>
          Tax Type:
          <select value={taxType} onChange={handleTaxTypeChange}>
            <option value="linear">Liniowy</option>
            <option value="progressive">Progresywny</option>
            <option value="flat">Ryczałt</option>
            <option value="taxcard">Karta podatkowa</option>
          </select>
        </label>
        <br />
        {taxType === 'flat' && (
          <label>
            Flat Tax Rate:
            <select value={flatTaxRate} onChange={handleFlatTaxRateChange}>
              <option value={17}>17%</option>
              <option value={15}>15%</option>
              <option value={14}>14%</option>
              <option value={12.5}>12.5%</option>
              <option value={12}>12%</option>
              <option value={10}>10%</option>
              <option value={8.5}>8.5%</option>
              <option value={5.5}>5.5%</option>
              <option value={3}>3%</option>
              <option value={2}>2%</option>
            </select>
          </label>
        )}
        {taxType === 'taxcard' && (
          <label>
            Wysokość karty podatkowej na obecny rok:
            <input type="number" value={taxCardRate} onChange={handleTaxRateChange} />
          </label>
          
        )
        }
        <br />
        <label>
          Dochód za rok obecny w przypadku ryczałtu proszę wpisać przychód z ..
          <input type="number" value={income} onChange={handleIncomeChange} />
        </label>
        
  
        <select value={miesiace} onChange={handleMiesiaceChange}>
          <option value={12}>12 miesięcy</option>
          <option value={11}>11 miesięcy</option>
          <option value={10}>10 miesięcy</option>
          <option value={9}>9 miesięcy</option>
          <option value={8}>8 miesięcy</option>
          <option value={7}>7 miesięcy</option>
          <option value={6}>6 miesięcy</option>
          <option value={5}>5 miesięcy</option>
          <option value={4}>4 miesiące</option>
          <option value={3}>3 miesiące</option>
          <option value={2}>2 miesiące</option>
          <option value={1}>1 miesiąc</option>  
          <option value={0}>tylko PIT</option>
        </select>
        <br/>
          Dochód z PIT za rok poprzedni w przypadku ryczałtu proszę wpisać przychód z PIT
          <input type="number" value={incomePit} onChange={handleIncomePitChange} />
        <label>
          <br/>
          Zapłacony podatek:
          {taxAmount}
        <p>
          <br></br>
          netto:
           {(nettoValuefull*0.81)/d}
          <br></br>
          {d}
        </p>
        </label>
  
        <p>
          <label>
            banki
            <li>mbank</li> 
            {(mbankLinearMonth*0.81)/12}
            <br></br>
            {(incomePit*0.4)/12}
            <br></br>
            {taxCardRate*5}
            <li>Santander</li>
            <li>PEKAO SA</li>
            <li>BNP Paribas</li>
            <li>Velo Bank - srednia z ostatnich 12mcy i z pit - nizsza z wartości</li>
            {(veloLinearMonth*0.81)/12}
            <li>Alior Bank</li>
            <li>Bank Pocztowy</li>
  <p></p>
            Kwota kredytu hipotecznego
            <input type="number" value={creditValue} onChange={handlecreditValueChange} />
            <br></br>
            Okres kredytowania
            <input type="number" value={loanPeriod} onChange={handleloanPeriodChange} />
  
          </label>
        </p>
  
        
  
        
      </form>
    );
  
   
  }
  
  
  export default TaxForm;
  